import React from 'react';

const ModalPopup = ({
  isOpen,
  title,
  message,
  onClose,
  onCancel,
  onConfirm,
  onDiscard,
  showSpinner,
  confirmLabel,
  cancelLabel,
  discardLabel,
  children,
  imageSrc // new prop for optional image
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={overlayStyle}>
      <div className="modal-content" style={modalStyle}>
        <h2 style={{ color: '#fff', fontSize: '1.8rem' }}>{title}</h2>
        {imageSrc && (
          <img src={imageSrc} alt="Popup Visual" style={{ maxWidth: '100%', height: 'auto', margin: '10px 0' }} />
        )}
        {showSpinner && <div className="spinner" style={spinnerStyle} />}
        {children}
        <p style={{ color: '#ccc' }}>{message}</p>
        <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
          {onCancel && (
            <button className="save-run-btn" onClick={onCancel}>{cancelLabel || 'Cancel'}</button>
          )}
          {onDiscard && (
            <button className="save-run-btn" onClick={onDiscard}>{discardLabel || 'Discard Data'}</button>
          )}
          {onConfirm && (
            <button className="save-run-btn" onClick={onConfirm}>{confirmLabel || 'OK'}</button>
          )}
          {!onConfirm && !onCancel && !onDiscard && (
            <button className="save-run-btn" onClick={onClose}>OK</button>
          )}
        </div>
      </div>
    </div>
  );
};

const overlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
};
const modalStyle = {
  backgroundColor: '#000',
  color: '#fff',
  padding: '20px',
  borderRadius: '10px',
  border: '2px solid #ccc',
  width: '90vw',
  maxWidth: '720px',
  maxHeight: '90vh',
  overflowY: 'auto',
  height: 'auto',
  textAlign: 'center',
  boxShadow: '0 0 20px rgba(255, 255, 255, 0.2)',
};
const spinnerStyle = {
  margin: '10px auto', width: '40px', height: '40px', border: '4px solid #ccc', borderTop: '4px solid #333',
  borderRadius: '50%', animation: 'spin 1s linear infinite'
};

export default ModalPopup;